var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9004 12.29V32.7H20.4404V12.29C20.4404 7.75002 16.7904 4.23002 11.9904 4.23002C7.19039 4.23002 3.54039 7.75002 3.54039 12.29V32.7H0.150391V12.29C0.150391 11.91 0.210388 11.65 0.210388 12.03H0.150391V0.830019H3.54039V4.03002C4.50039 2.75002 8.08039 0.77002 11.9904 0.77002C18.4504 0.77002 23.8904 6.02002 23.8904 12.29H23.9004Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerN);
export default __webpack_public_path__ + "static/media/LOWER_N.04c59a0bc03621a60c863a5bc70c2d5a.svg";
export { ForwardRef as ReactComponent };